// Quem abre o link de vínculo (/connect/discord#code=...) deslogado passa pelo login. O destino é guardado
// aqui e retomado depois do login. O código expira em 10 minutos, então não fica guardado além da sessão.
const KEY = 'tr_pending_connect'

const savePendingConnect = (target: string): void => {
  try {
    if (target.startsWith('/connect/')) sessionStorage.setItem(KEY, target)
  } catch {
    // sessionStorage indisponível (janela privada): o usuário só volta a abrir o link.
  }
}

const takePendingConnect = (): string | null => {
  try {
    const value = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return value && value.startsWith('/connect/') ? value : null
  } catch {
    return null
  }
}

export {savePendingConnect, takePendingConnect}
